import React from "react";
import { Row, Col, Card, ProgressBar } from "react-bootstrap";
import { FiTrendingUp } from "react-icons/fi";

const statsData = [
  {
    title: "Total Invoice",
    amount: "$3,237.94",
    progress: 85,
    color: "pink",
    change: "+32.40%",
    status: "success",
  },
  {
    title: "Outstanding",
    amount: "$3,237.94",
    progress: 50,
    color: "purple",
    change: "-4.40%",
    status: "danger",
  },
  {
    title: "Draft",
    amount: "$3,237.94",
    progress: 30,
    color: "warning",
    change: "12%",
    status: "success",
  },
  {
    title: "Total Overdue",
    amount: "$3,237.94",
    progress: 20,
    color: "danger",
    change: "-15.40%",
    status: "danger",
  },
];

const InvoiceStats = () => {
  return (
    <Row>
      {statsData.map((item, index) => (
        <Col xl={3} sm={6} key={index} className="mb-3">
          <Card className="invoice-card h-100">
            <Card.Body>
              
              {/* TITLE + AMOUNT */}
              <div className="mb-2">
                <p className="invoice-title">{item.title}</p>
                <h5 className="invoice-amount">{item.amount}</h5>
              </div>

              {/* PROGRESS BAR */}
              <div className="mb-2">
                <ProgressBar
                  now={item.progress}
                  className={`custom-progress ${item.color}`}
                />
              </div>

              {/* CHANGE */}
              <p className="invoice-change">
                <span className={`change-${item.status}`}>
                  <FiTrendingUp className="me-1" />
                  {item.change}
                </span>{" "}
                from last month
              </p>

            </Card.Body>
          </Card>
          <style>
               {
                    `
                    /* CARD */
.invoice-card {
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  box-shadow: none;
}

/* TITLE */
.invoice-title {
  font-size: 13px;
  color: #6b7280;
  margin-bottom: 4px;
}

/* AMOUNT */
.invoice-amount {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}

/* PROGRESS BAR BASE */
.custom-progress {
  height: 5px;
  background-color: #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.custom-progress .progress-bar {
  border-radius: 10px;
}

/* COLORS (match your design exactly) */
.custom-progress.pink .progress-bar {
  background-color: #ec4899;
}

.custom-progress.purple .progress-bar {
  background-color: #8b5cf6;
}

.custom-progress.warning .progress-bar {
  background-color: #f59e0b;
}

.custom-progress.danger .progress-bar {
  background-color: #ef4444;
}

/* CHANGE TEXT */
.invoice-change {
  font-size: 13px;
  color: #6b7280;
  display: flex;
  align-items: center;
}

/* POSITIVE */
.change-success {
  color: #16a34a;
  display: flex;
  align-items: center;
}

/* NEGATIVE */
.change-danger {
  color: #dc2626;
  display: flex;
  align-items: center;
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .invoice-amount {
    font-size: 18px;
  }
}`
               }
          </style>
        </Col>
      ))}
    </Row>
  );
};

export default InvoiceStats;